import request from './index'
import store from '@/store'
import router from '@/router'

// 是否正在刷新token
let isRefreshing = false
// 存储需要重试的请求队列
let requests = []

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 从localStorage中获取token
    const token = localStorage.getItem('access_token')

    if (token) {
      // 设置请求头
      config.headers['Authorization'] = `Bearer ${token}`
  
    } else {
      console.log('未找到token，不设置Authorization头')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  async error => {
    const { config, response } = error
    
    // 处理token过期情况
    if (response && response.status === 401) {
      // 对登录接口特殊处理，不进行token刷新
      if (config.url === '/v1/auth/login') {
        // 登录请求失败，直接返回错误，不执行token刷新
        return Promise.reject(error)
      }
      
      // 如果当前请求不是刷新token的请求
      if (config.url !== '/v1/auth/refresh') {
        // 如果正在刷新token，则将当前请求加入队列
        if (isRefreshing) {
          return new Promise(resolve => {
            requests.push(() => {
              resolve(request(config))
            })
          })
        }
        
        // 开始刷新token
        isRefreshing = true
        try {
          await store.dispatch('auth/refreshToken')
          
          // 执行队列中的请求
          requests.forEach(cb => cb())
          requests = []
          
          // 重新请求当前失败的请求
          return request(config)
        } catch (err) {
          // 刷新token失败，跳转到登录页
          store.dispatch('auth/logout')
          router.push('/login')
          return Promise.reject(err)
        } finally {
          isRefreshing = false
        }
      }
    }
    
    // 处理其他错误
    return Promise.reject(error)
  }
)

export default request